import { PaymentData } from "./payments-state";

export const createPaymentRequestData = (
  paymentData: PaymentData,
  scheduleFlag: boolean,
) => {
  const requestData = {
    paymentDate: paymentData.paymentDate,
    paymentAmount: paymentData.paymentAmount,
    feeTotal: paymentData.feeTotal,
    // currencyCode: this defaults to USD for now
    paymentMethodType: paymentData.paymentMethod?.paymentMethodType,
    accountInformationId: paymentData.accountInformationId,
    note: scheduleFlag ? undefined : paymentData.note ? paymentData.note : null,
    paymentType: paymentData.paymentType || 0,
    savedPaymentMethodId: paymentData.savedPaymentMethodId || undefined,
    firstName: paymentData.firstName,
    lastName: paymentData.lastName,
    routingNumber: paymentData.paymentMethod
      ? paymentData.paymentMethod.routingNumber
      : null,
    bankAccount: paymentData.paymentMethod
      ? paymentData.paymentMethod.accountNumber
      : null,
    bankAccountType: paymentData.paymentMethod
      ? paymentData.paymentMethod.bankAccountType
      : // ? typeMapper(paymentData.paymentMethod.bankAccountType, "account")
        // : 0
        0,
    bankName: paymentData.paymentMethod
      ? paymentData.paymentMethod.bankName
      : null,
    // transactionDate: Date(),
    email: paymentData.email ? paymentData.email : null,
    applicationName: "firstech",
    cardType: paymentData.paymentMethod
      ? paymentData.paymentMethod.cardType
      : null,
    cardToken: paymentData.paymentMethod
      ? paymentData.paymentMethod.tokenizedCardData
      : null,
    lastFour: paymentData.paymentMethod
      ? paymentData.paymentMethod.lastFour
      : null,
    expirationDate: paymentData.paymentMethod
      ? paymentData.paymentMethod.expirationDate
      : null,
    cvv2: paymentData.paymentMethod ? paymentData.paymentMethod.cvv2 : null,
    cardHolderName: paymentData.paymentMethod
      ? paymentData.paymentMethod.cardHolderName
      : null,
    address: paymentData.paymentMethod
      ? paymentData.paymentMethod.address
      : null,
    isTest: paymentData.isTest ? paymentData.isTest : false,
    clientId: paymentData?.clientId,
    googlePayload: paymentData.googlePayload,

    scheduledPaymentDate: scheduleFlag ? paymentData.paymentDate : undefined,
    paymentMethodId: scheduleFlag
      ? paymentData.savedPaymentMethodId
      : undefined,
    paymentTypeCode: scheduleFlag ? paymentData.paymentType : undefined,
    userId: scheduleFlag ? paymentData.userId : undefined,
    paymentAmountType: paymentData.paymentAmountType,
    customerReferenceNumber: paymentData.customerReferenceNumber
      ? paymentData.customerReferenceNumber
      : null,
    authReferenceId: paymentData.paymentMethod
      ? paymentData.paymentMethod.authReferenceId
      : null,
    cardBinType: paymentData.paymentMethod
      ? paymentData.paymentMethod.cardBinType
      : null,
    walletType: paymentData.walletType || null,
    jsonPayload: paymentData.jsonPayload ? paymentData.jsonPayload : undefined,
  };

  return requestData;
};
